import React from 'react';
import { Card, Col, Radio, Row, Typography } from 'antd';
import { InboxOutlined, LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { SupplierOrderPurchaseMode } from '../supplierOrderCreateMode';

const { Text } = Typography;

interface Props {
  value?: SupplierOrderPurchaseMode;
  onChange?: (value: SupplierOrderPurchaseMode) => void;
}

const SupplierOrderPurchaseModeSelector: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation(['orders']);
  const modes: Array<{
    value: SupplierOrderPurchaseMode;
    icon: React.ReactNode;
    title: string;
    description: string;
  }> = [
    {
      value: 'CUSTOMER_ORDER',
      icon: <LinkOutlined />,
      title: t('orders:supplierOrders.purchaseMode.customerOrder'),
      description: t('orders:supplierOrders.purchaseMode.customerOrderHelp'),
    },
    {
      value: 'STOCK',
      icon: <InboxOutlined />,
      title: t('orders:supplierOrders.purchaseMode.stock'),
      description: t('orders:supplierOrders.purchaseMode.stockHelp'),
    },
  ];

  return (
    <Radio.Group value={value} onChange={(event) => onChange?.(event.target.value)} style={{ width: '100%' }}>
      <Row gutter={[12, 12]}>
        {modes.map((mode) => {
          const selected = value === mode.value;
          return (
            <Col xs={24} md={12} key={mode.value}>
              <label style={{ display: 'block', cursor: 'pointer', height: '100%' }}>
                <Card
                  size="small"
                  styles={{ body: { padding: 16 } }}
                  style={{
                    height: '100%',
                    borderColor: selected ? '#1677ff' : '#d9d9d9',
                    background: selected ? '#f0f7ff' : '#fff',
                    boxShadow: selected ? '0 0 0 2px rgba(22,119,255,0.08)' : 'none',
                    transition: 'border-color 160ms ease, background 160ms ease, box-shadow 160ms ease',
                  }}
                >
                  <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <Radio value={mode.value} style={{ marginTop: 2 }} />
                    <div style={{ minWidth: 0 }}>
                      <Text strong style={{ display: 'block', fontSize: 15 }}>
                        <span style={{ color: selected ? '#1677ff' : '#475569', marginRight: 8 }}>{mode.icon}</span>
                        {mode.title}
                      </Text>
                      <Text type="secondary" style={{ display: 'block', marginTop: 4, lineHeight: 1.45 }}>
                        {mode.description}
                      </Text>
                    </div>
                  </div>
                </Card>
              </label>
            </Col>
          );
        })}
      </Row>
    </Radio.Group>
  );
};

export default SupplierOrderPurchaseModeSelector;
